export default __webpack_public_path__ + "static/media/hero-illustration.0bbd4c36.png";